module.exports = __webpack_public_path__ + "img/exit.8d1e35e0.svg";